import PropTypes from 'prop-types'
import React from 'react'
import SydButton from '../../../../../commonDesign/Button'
import { useCheckPolicy } from '../../../../../../hooks'

function ViewContentHeaderControls ({
  onToggleDesigner,
  designerLoading,
  views,
  viewMode,
  onViewModeChange
}) {
  const canAccessDesigner = useCheckPolicy('internalOnly')

  return (
    <div className='flex flex-col gap-sm items-end' style={{ paddingRight: 2 }}>
      <div className='flex items-center gap-sm'>
        {canAccessDesigner ? (
          <SydButton
            variant='ai'
            icon='sparkles'
            size='md'
            onClick={onToggleDesigner}
            processing={designerLoading}
          >
            Designer
          </SydButton>
        ) : null}
      </div>

      <div className='flex items-center gap-sm'>
        {views.map((view) => (
          <SydButton
            key={view.id}
            {...view}
            variant={viewMode === view.id ? 'primary' : 'secondary'}
            onClick={() => onViewModeChange(view.id)}
          >{view.title}
          </SydButton>
        ))}
      </div>
    </div>
  )
}

ViewContentHeaderControls.propTypes = {
  onToggleDesigner: PropTypes.func,
  designerLoading: PropTypes.bool,
  views: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.string,
    size: PropTypes.string
  })),
  viewMode: PropTypes.string,
  onViewModeChange: PropTypes.func
}

ViewContentHeaderControls.defaultProps = {
  onToggleDesigner: undefined,
  designerLoading: false,
  views: [],
  viewMode: '',
  onViewModeChange: undefined
}

export default ViewContentHeaderControls
